// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f6f9fb;
  padding: 16px 16px;
}

  .search-panel__input {
    flex: 1;
    border-radius: 4px;
  }

  .search-panel__filter-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    fill: #333;
    width: 40px;
    height: 40px;
  }

  .search-panel__filter-btn:focus,
    .search-panel__filter-btn:hover {
      fill: #1890ff;
    }

.table-filter,
.date-filter,
.main-filters {
  width: 382px;
  height: 32px;
}

.date-filter {
  margin: 0px 0px 20px 0px;
}

.main-filters {
  margin: 10px 0px 10px 5px;
}

.main-filters span,
.main-filters a {
  color: #192033;
}

/* News and Events */
.news-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.news-page-header {
  width: 414px;
  height: 120px;
  padding-left: 16px;
  padding-bottom: 16px;
  background: #f6f9fb;
}

.header span {
  font-family: Golos;
  font-style: normal;
  font-weight: 600;
  color: #192033;
}

.news-filter-popover-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.news-page-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}

.news-page-container {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}

.news-list-pagination {
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}

.news-list-pagination__pagination {
    width: 75%;
    text-align: right;
  }

.news-list-pagination__counter {
    width: 25%;
    margin-right: 20px;
  }

.news-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  z-index: 1000;
  cursor: auto;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    rgb(116, 116, 116, 0.6)
  );
}

.news-page-info {
  display: flex;
  padding: 16px;
}

.news-page-text {
  cursor: pointer;
}

.news-page-text p,
.news-page-text span {
  font-family: Golos;
  font-style: normal;
  font-weight: normal;
}

.news-page-text p {
  margin-top: 10px;
  font-size: 12px;
  line-height: 16px;
  color: #45454f;
}

.news-page-text span {
  font-size: 14px;
  line-height: 20px;
  color: #192033;
  padding-bottom: 10px;
}

.news-page-img img {
  height: 80px;
  width: 100px;
  -o-object-fit: cover;
     object-fit: cover;
}

.news-page-button {
  float: right;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.news-page-button .ant-checkbox {
    margin-right: 63px;
    border: 1px solid #fd0d0d00;
  }

.add-bulk-publish {
  display: flex;
  padding-left: 20px;
  font-size: 14px;
  align-items: center;
  margin-bottom: 5px;
  justify-content: flex-end;
}

.add-bulk-publish .add-bulk-publish-highlight {
    cursor: pointer;
    display: flex;
    padding: 5px 15px;
    border: 0px none;
    border-radius: 4px;
    background-color: #e1e1e1;
  }

.add-bulk-publish .add-bulk-publish-highlight > p {
      margin: 0 10px 0 0;
    }

.img-carousel {
  width: 300px;
  height: 240px;
  float: left;
  margin-right: 20px;
  margin-bottom: 10px;
}

.news-description {
  overflow-y: unset !important;
  height: auto !important;
  line-height: 1.5715 !important;
  padding: 0 !important;
}

.news-description p {
    text-align: left !important;
    margin-bottom: 1em !important;
  }

.news-description ul li {
    list-style-position: inside;
    position: relative;
    left: 20px;
  }

.news-info-row {
  display: flex;
  white-space: pre-wrap;
}

.news__content {
  width: 100%;
}

.news-filter-popover-content {
  width: 380px;
}

.news-modal-footer-content {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
}

.news-check-box-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.news-check-box-warning {
  margin-bottom: 10px;
}

.news-check-box-label {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Module/News/style.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAY;EACZ,mBAAwB;EACxB,kBAAkB;AAqBpB;;EAnBE;IACE,OAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAiB;IACjB,WAAW;IACX,YAAY;EAMd;;EAJE;;MAEE,aAAW;IACb;;AAIJ;;;EAGE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAwB;AAC1B;;AAEA;EACE,kBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AAWb;;AATE;IACE,UAAU;IACV,iBAAiB;EACnB;;AAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AAMrB;;AAJE;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;AAGF;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAc3B;;AAZE;IACE,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAK3B;;AAHE;MACE,kBAAkB;IACpB;;AAIJ;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AAUvB;;AATE;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;AACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;EACZ;;AAGF;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\n.search-panel {\n  display: flex;\n  align-items: center;\n  gap: $sm-gap;\n  background: $white-light;\n  padding: 16px 16px;\n\n  &__input {\n    flex: 1;\n    border-radius: 4px;\n  }\n\n  &__filter-btn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    fill: $black-text;\n    width: 40px;\n    height: 40px;\n\n    &:focus,\n    &:hover {\n      fill: $blue;\n    }\n  }\n}\n\n.table-filter,\n.date-filter,\n.main-filters {\n  width: 382px;\n  height: 32px;\n}\n\n.date-filter {\n  margin: 0px 0px 20px 0px;\n}\n\n.main-filters {\n  margin: 10px 0px 10px 5px;\n}\n\n.main-filters span,\n.main-filters a {\n  color: $black-accent;\n}\n\n/* News and Events */\n.news-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.news-page-header {\n  width: 414px;\n  height: 120px;\n  padding-left: 16px;\n  padding-bottom: 16px;\n  background: $white-light;\n}\n\n.header span {\n  font-family: $font-main;\n  font-style: normal;\n  font-weight: 600;\n  color: $black-accent;\n}\n\n.news-filter-popover-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.news-page-list {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: auto;\n  position: relative;\n}\n\n.news-page-container {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%;\n}\n\n.news-list-pagination {\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n\n  &__pagination {\n    width: 75%;\n    text-align: right;\n  }\n\n  &__counter {\n    width: 25%;\n    margin-right: 20px;\n  }\n}\n\n.news-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  z-index: 1000;\n  cursor: auto;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.1) 0%,\n    rgb(116, 116, 116, 0.6)\n  );\n}\n\n.news-page-info {\n  display: flex;\n  padding: 16px;\n}\n\n.news-page-text {\n  cursor: pointer;\n}\n\n.news-page-text p,\n.news-page-text span {\n  font-family: $font-main;\n  font-style: normal;\n  font-weight: normal;\n}\n\n.news-page-text p {\n  margin-top: 10px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $black-secondary;\n}\n\n.news-page-text span {\n  font-size: 14px;\n  line-height: 20px;\n  color: $black-accent;\n  padding-bottom: 10px;\n}\n\n.news-page-img img {\n  height: 80px;\n  width: 100px;\n  object-fit: cover;\n}\n\n.news-page-button {\n  float: right;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  .ant-checkbox {\n    margin-right: 63px;\n    border: 1px solid #fd0d0d00;\n  }\n}\n\n.add-bulk-publish {\n  display: flex;\n  padding-left: 20px;\n  font-size: 14px;\n  align-items: center;\n  margin-bottom: 5px;\n  justify-content: flex-end;\n\n  .add-bulk-publish-highlight {\n    cursor: pointer;\n    display: flex;\n    padding: 5px 15px;\n    border: 0px none;\n    border-radius: 4px;\n    background-color: #e1e1e1;\n\n    & > p {\n      margin: 0 10px 0 0;\n    }\n  }\n}\n\n.img-carousel {\n  width: 300px;\n  height: 240px;\n  float: left;\n  margin-right: 20px;\n  margin-bottom: 10px;\n}\n\n.news-description {\n  overflow-y: unset !important;\n  height: auto !important;\n  line-height: 1.5715 !important;\n  padding: 0 !important;\n  p {\n    text-align: left !important;\n    margin-bottom: 1em !important;\n  }\n  ul li {\n    list-style-position: inside;\n    position: relative;\n    left: 20px;\n  }\n}\n\n.news-info-row {\n  display: flex;\n  white-space: pre-wrap;\n}\n\n.news__content {\n  width: 100%;\n}\n\n.news-filter-popover-content {\n  width: 380px;\n}\n\n.news-modal-footer-content {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  flex-direction: column;\n}\n\n.news-check-box-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.news-check-box-warning {\n  margin-bottom: 10px;\n}\n\n.news-check-box-label {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
